<template>
    <!-- 관리자 상단 바 — 사내 디자인 시스템 GlobalHeader 와 같은 모양·수치(높이 48, 좌우 16, 아이콘 버튼 26, 텍스트 컨트롤 28).
         왼쪽: 메뉴 접기 · 홈 · 지금 위치(브레드크럼). 오른쪽: 다른 화면으로 가는 버튼. -->
    <header class="ds-global-header">
        <button type="button" class="ds-gh-icon-btn" aria-label="메뉴 접기·펼치기" title="메뉴 접기·펼치기"
                :aria-expanded="String(!navCollapsed)" @click="$emit('toggle-nav')">
            <AppIcon name="layout-sidebar"/>
        </button>
        <span class="ds-gh-divider" aria-hidden="true"/>
        <router-link :to="{ name: 'ManagingAssessment' }" class="ds-gh-icon-btn" aria-label="관리자 홈" title="관리자 홈">
            <AppIcon name="home"/>
        </router-link>
        <nav class="ds-gh-crumbs" aria-label="현재 위치">
            <template v-for="(crumb, i) in crumbs">
                <span :key="`sep-${i}`" class="ds-gh-crumb-sep" aria-hidden="true">/</span>
                <span :key="`crumb-${i}`" class="ds-gh-crumb" :class="{ 'is-current': i === crumbs.length - 1 }"
                      :aria-current="i === crumbs.length - 1 ? 'page' : null">{{ crumb }}</span>
            </template>
        </nav>
        <div class="ds-gh-actions">
            <b-btn :to="{ name: 'Main' }" size="sm" variant="outline-secondary" class="ds-gh-text-btn">
                <AppIcon name="home" class="mr-1"/>HOME
            </b-btn>
            <b-btn :to="{ path: '/project_code_list' }" size="sm" variant="outline-secondary" class="ds-gh-text-btn">
                <AppIcon name="layout-dashboard" class="mr-1"/>ADMIN
            </b-btn>
        </div>
    </header>
</template>

<script>
import {activeTrail} from '../../layout/admin-nav';

export default {
    name: 'AdminGlobalHeader',
    props: {
        navCollapsed: {type: Boolean, default: false},
    },
    computed: {
        crumbs() {
            return activeTrail(this.$route.name, this.$route.meta && this.$route.meta.title_kr).crumbs;
        },
    },
};
</script>

<style lang="scss">
.ds-global-header {
    position: sticky;
    top: 0;
    z-index: 21;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: 8px;
    height: 48px;
    padding: 0 16px;
    border-bottom: 1px solid var(--ds-border);
    background-color: var(--ds-surface);
}

// 아이콘 버튼(ds-gh-icon-btn) · 텍스트 버튼(ds-gh-text-btn)은 원청 상단 바와 같이 쓰므로 styles/ds/_bar.scss

.ds-gh-divider {
    flex-shrink: 0;
    width: 1px;
    height: 16px;
    background-color: var(--ds-border);
}

.ds-gh-crumbs {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    margin-left: 4px;
    font-size: 13px;
}

.ds-gh-crumb-sep {
    color: var(--ds-fg-disabled);
}

.ds-gh-crumb {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: var(--ds-fg-muted);

    &.is-current {
        color: var(--ds-fg);
        font-weight: 500;
    }
}

.ds-gh-actions {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: 8px;
    margin-left: auto;
    padding-left: 12px;
}
</style>
